import { type SxProps, type Theme } from '@mui/material'

export const styles = {
  invoicingContainer: {
    mb: 2
  } satisfies SxProps<Theme>,
  invoicingNote: {
    mt: 2,
    fontStyle: 'italic'
  } satisfies SxProps<Theme>,
  choiceContainer: {
    display: 'flex',
    flexDirection: 'column'
  } satisfies SxProps<Theme>,
  infoText: {
    color: 'text.secondary',
    fontStyle: 'italic',
    ml: 4,
    wordBreak: 'break-word'
  } satisfies SxProps<Theme>,
  textFieldWrapper: {
    mt: 1
  } satisfies SxProps<Theme>,
  filePickerWrapper: {
    width: '100%',
    maxWidth: '600px'
  } satisfies SxProps<Theme>,
  modalWarningText: {
    mt: '4px'
  } satisfies SxProps<Theme>
}
